import { useCallback, useEffect, useState } from 'react'
import { getUsage } from 'services/auth.service'

// Plan usage of the signed-in client ({ plan, used, limit, remaining, reached }).
// null while loading or when it can't be read (the UI then shows no limits).
const useUsage = () => {
  const [usage, setUsage] = useState(null)
  const refresh = useCallback(async () => {
    try { setUsage(await getUsage()) } catch { setUsage(null) }
  }, [])
  useEffect(() => { refresh() }, [refresh])
  return { usage, refresh, setUsage }
}

export default useUsage
